



































import Vue from 'vue';

export default Vue.extend({
  name: 'GroupsDisplay',
  props: {
    groups: {
      type: Array as () => Group[],
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    isFetchingJWT: {
      type: Boolean,
      required: true,
    },
    userId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      unsortedUsers: [],
      headers: [
        {
          text: 'Contact Name',
          align: 'left',
          value: 'contactName',
          sortable: false,
        },
        {
          text: 'Role',
          align: 'left',
          value: 'role',
        },
        {
          text: 'Group Name',
          align: 'left',
          value: 'groupName',
        },
        {
          text: 'Group Number',
          align: 'left',
          value: 'groupNumber',
        },
        {
          text: 'Health Plan Client ID',
          align: 'left',
          value: 'partnerGroupNumber',
        },
        {
          text: '',
          sortable: false,
        },
      ],
    };
  },
  methods: {
    getContactName(group: Group): string {
      return group.hasAllLocationAccess ?
        `${group.lastName}, ${group.firstName} *` : `${group.lastName}, ${group.firstName}`;
    },
  },
});
